import { InjectionToken } from '@angular/core';

export interface AccessTokenInterceptorConfig {
  ignoreUrls: string[];
}

export const ACCESS_TOKEN_INTERCEPTOR_CONFIG =
  new InjectionToken<AccessTokenInterceptorConfig>('AccessTokenInterceptorConfig');
